import { Colors } from 'assets/colors';
import { css } from 'styled-components';

/**
 * Shared PosHub console tokens — aligned with Merchant Detail / Nibble admin (Manrope, #131b1f, WL primary).
 */
export const PH = {
  text: Colors.textPrimary1,
  textMuted: '#717679',
  textLabel: '#4f566b',
  border: '#e7e8e9',
  borderStrong: '#d8dce2',
  surface: '#ffffff',
  surfaceMuted: '#fafbfc',
  primary: Colors.primary1,
  error: '#c7322d',
  success: '#0e623f',
  successBg: 'rgba(75, 180, 58, 0.12)',
  fontSizeSm: '13px',
  fontSizeBase: '15px',
  fontSizeLg: '16px',
  fontSizeSection: '17px',
  fontSizeTitle: '18px',
  lineHeightTight: 1.35,
  lineHeightBody: 1.5,
};

/** Reusable Ant Design table look for Catalog + Menus */
export const poshubTableStyles = css`
  .poshub-console-table.ant-table-wrapper {
    .ant-table {
      font-size: ${PH.fontSizeBase};
      line-height: 22px;
      color: ${PH.text};
    }

    .ant-table-container {
      border: 1px solid ${PH.border};
      border-radius: 4px;
    }

    .ant-table-thead > tr > th {
      padding: 12px 16px;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: ${PH.textLabel};
      background: #f2f4f7;
      border-bottom: 1px solid ${PH.border};

      &::before {
        display: none;
      }
    }

    .ant-table-tbody > tr > td {
      padding: 12px 16px;
      border-color: ${PH.border};
      font-weight: 500;
      font-size: ${PH.fontSizeBase};
      vertical-align: middle;
    }

    .ant-table.ant-table-small .ant-table-tbody > tr > td {
      font-size: ${PH.fontSizeBase};
      padding: 10px 16px;
    }

    .ant-table.ant-table-small .ant-table-thead > tr > th {
      font-size: 12px;
      padding: 10px 16px;
    }

    .ant-table-tbody > tr:hover > td {
      background: #f9fafb;
    }
  }

  .poshub-row-action-btn.ant-btn.ant-btn-icon-only {
    width: 36px;
    height: 36px;
    font-size: 16px;
    color: ${PH.textMuted};
    border-radius: 4px;

    &:not(:disabled):hover {
      color: ${PH.primary};
      background: rgba(0, 0, 0, 0.04);
    }
  }
`;

export const poshubTabsStyles = css`
  .poshub-console-tabs.ant-tabs {
    .ant-tabs-nav {
      margin-bottom: 20px;
      padding-bottom: 0;
    }

    .ant-tabs-nav::before {
      border-bottom-color: ${PH.border};
    }

    .ant-tabs-tab {
      padding: 12px 20px;
      font-size: ${PH.fontSizeBase};
      font-weight: 600;
      line-height: 22px;
    }

    .ant-tabs-tab + .ant-tabs-tab {
      margin: 0 0 0 4px;
    }

    .ant-tabs-tab-btn {
      color: ${PH.textMuted};
      text-shadow: none;
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${PH.text};
      font-weight: 700;
    }

    .ant-tabs-ink-bar {
      background: ${PH.primary};
      height: 3px;
      border-radius: 2px 2px 0 0;
    }

    .ant-tabs-content-holder {
      font-size: ${PH.fontSizeBase};
      line-height: ${PH.lineHeightBody};
      color: ${PH.text};
    }
  }
`;
